/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './TrustedContactsDeleteModal.scss';

import { array, func, object } from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import BaseModal from 'components/shared/Modal/BaseModal';
import ModalLoadingSpinner from 'components/shared/Modal/ModalLoadingSpinner';
import {
  getClientMissions,
  updateCustomerPreferences
} from 'services/Rest';
import { NON_BREAKING_SPACE } from 'services/Formats';
import { getCustomerTrustedContacts } from 'state/customer/CustomerSelectors';
import { TrustedContactsButtonWithPermissions } from 'components/layouts/Preferences/TrustedContacts/TrustedContactsModal/TrustedContactsModal';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import Store from 'state/Store';
import { errorUpdateTrustedContacts } from 'state/preferences/PreferencesActions';
import { clientMissionsEnabled, isTrustedContactsAccountNumberEnabled } from 'services/FeatureFlags';
import { getAccountsById } from 'state/account/AccountSelectors';
import { applyAccountNumbersToContacts } from 'services/Preferences';

const Name = ({ firstName, lastName }) => (
  <Fragment>
    {firstName} {lastName}
  </Fragment>
);

const NameWithPermissions = WithUserPermissions(Name);

// TODO : Refactor to DeleteConfirmationModal for consistent user experience
class TrustedContactsDeleteModal extends React.Component {
  state = {
    updatingContacts: false
  };

  deleteTrustedContact = () => {
    const { allTrustedContacts, contact, accountsById } = this.props;
    const { accountId, sequenceNumber } = contact;
    let updatedAllTrustedContacts = allTrustedContacts.map((contact) => {
      const current =
        contact.accountId === accountId &&
        contact.sequenceNumber === sequenceNumber;
      if (current) {
        return {
          ...contact,
          disposition: { action: 'remove' }
        };
      }
      return {
        ...contact
      };
    });

    this.setState({
      updatingContacts: true
    });
    if(isTrustedContactsAccountNumberEnabled()) {
      updatedAllTrustedContacts = applyAccountNumbersToContacts(updatedAllTrustedContacts, accountsById)
    }
    updateCustomerPreferences({
      trustedContacts: updatedAllTrustedContacts
    },
      () => {
        if(clientMissionsEnabled()) {
          try{
            getClientMissions();
          } catch(e) {
            //do nothing
          }
        }
      },
      () => {Store.dispatch(errorUpdateTrustedContacts())});
  };

  render() {
    const { account, contact, onClose } = this.props;
    const { updatingContacts } = this.state;
    const { name: { accountName } = {} } = account;
    const { firstName, lastName } = contact;

    return (
      <BaseModal
        className="trusted-contacts-delete-modal"
        disableClickOff={true}
        hideAnchor={true}
        hideClose={true}
        isOpen={true}
        title={null}>
        {!updatingContacts && (
          <Fragment>
            <div className="trusted-contacts-delete-modal-content">
              <div className="modal-header">
                Delete{NON_BREAKING_SPACE}
                <NameWithPermissions
                  firstName={firstName}
                  lastName={lastName}
                  styleOverride={{ fontFamily: 'Nimbus Sans Bold' }}
                  shouldMask
                />
                {NON_BREAKING_SPACE}Trusted Contact
              </div>
              <div className="modal-content">
                This will permanently delete{' '}
                <NameWithPermissions
                  firstName={firstName}
                  lastName={lastName}
                  shouldMask
                />
                {NON_BREAKING_SPACE}from {accountName}
              </div>
              <div className="trusted-contacts-delete-button-group">
                <button className="secondary-button" onClick={onClose}>
                  Cancel
                </button>
                <TrustedContactsButtonWithPermissions
                  className="primary-button delete-button"
                  onClick={this.deleteTrustedContact}
                  text="Delete"
                  shouldDisable
                />
              </div>
            </div>
          </Fragment>
        )}
        {updatingContacts && (
          <ModalLoadingSpinner label="Updating Trusted Contacts" />
        )}
      </BaseModal>
    );
  }
}

TrustedContactsDeleteModal.propTypes = {
  account: object.isRequired,
  allTrustedContacts: array.isRequired,
  contact: object.isRequired,
  onClose: func.isRequired
};

const mapStateToProps = (state) => ({
  allTrustedContacts: getCustomerTrustedContacts(state),
  accountsById: getAccountsById(state)
});

export default connect(mapStateToProps)(TrustedContactsDeleteModal);
